// extracted by mini-css-extract-plugin
module.exports = {"powerstream-cooperation-C":"C_powerstream-cooperation-C___BRCa"};